// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".t-alert{border-radius:3px}.t-alert ul{margin-bottom:0}.t-alert .alert-link a{color:inherit!important;text-transform:uppercase;text-decoration:underline}.t-alert .fa-border{border-color:#147249}", ""]);
// Exports
module.exports = exports;
